import { render, staticRenderFns } from "./FormatsCopiesAttributeEditor.vue?vue&type=template&id=b8215d7c"
import script from "./FormatsCopiesAttributeEditor.vue?vue&type=script&lang=js"
export * from "./FormatsCopiesAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports